__webpack_require__.p = "/static/ascend-foundation-web/";